import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import Pricing from '../page/components/landing/Pricing';
import analytics from '../../libs/analytics';
import '../page/landing.css';
import './style.css';

function Plan({ user }: any) {
  const navigate = useNavigate();

  const getTitle = () => {
    switch (String(user.planId)) {
      case '3':
      case '4':
        return { main: 'Parabéns! Você já possui o', highlight: 'melhor plano' };
      case '2':
        return { main: 'Quer evoluir ainda mais?', highlight: 'Assine o Anual e economize!' };
      default:
        return { main: 'Escolha seu plano e', highlight: 'comece a falar hoje' };
    }
  };

  const getSubtitle = () => {
    switch (String(user.planId)) {
      case '3':
        return 'Aproveite todos os benefícios do plano Anual!';
      case '4':
        return 'Aproveite todos os benefícios da sua Assinatura!';
      case '2':
        return 'Faça upgrade para o plano Anual e economize R$360 por ano.';
      default:
        return 'Invista em você. Sua fluência em inglês está a um passo de distância.';
    }
  };

  const title = getTitle();

  useEffect(() => {
    analytics.planPageViewed(String(user.planId || '1'));
  }, []);

  return (
    <div className="landing-page Plan-page">
      <div className="container mx-auto px-4 pt-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-8"
        >
          <h2 className="font-display text-3xl md:text-4xl lg:text-5xl font-bold mb-6">
            {title.main}{" "}
            <span className="text-gradient glow-text">{title.highlight}</span>
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            {getSubtitle()}
          </p>
        </motion.div>
      </div>
      
      <Pricing currentPlanId={String(user.planId)} showHeader={false} />
      
      <div className="container mx-auto px-4 pb-8 text-center">
        <button
          className="text-muted-foreground hover:text-foreground underline transition-colors"
          onClick={() => navigate(-1)}
        >
          Voltar
        </button>
      </div>
    </div>
  );
}

export default Plan;
